// Origins the Contentful web app is served from. Its entry editor is the only parent frame the
// live preview SDK will talk to.
export const CONTENTFUL_APP_ORIGINS = ['https://app.contentful.com', 'https://app.eu.contentful.com']

/**
 * True only when the page is running inside the Contentful entry editor's preview iframe.
 *
 * Everywhere else - the live site, local browsing, Storybook, Cypress, unit tests - the live
 * preview SDK is never initialised, and calling into it throws. `ContentfulLivePreview.initialized`
 * looks like the same check but reads a static off the SDK singleton, which a bundler can duplicate
 * across the `@contentful/live-preview` and `@contentful/live-preview/react` entry points.
 *
 * `ancestorOrigins` is Chromium and WebKit only, so Firefox falls back to the referrer.
 */
export const isContentfulPreviewFrame = (): boolean => {
  if (typeof window === 'undefined' || window.self === window.top) return false

  const { ancestorOrigins } = window.location
  if (ancestorOrigins) return CONTENTFUL_APP_ORIGINS.some(origin => ancestorOrigins.contains(origin))

  return CONTENTFUL_APP_ORIGINS.some(origin => document.referrer.startsWith(origin))
}
